exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tableNumberDropdown-formControl{width:100%}.tableNumberDropdown-select{width:100%;font-family:'Lato-Regular', sans-serif;color:var(--text)}.tableNumberDropdown-titleAndDropdownContainer{display:flex;margin:8px 0 0 0;justify-content:space-between}.tableNumberDropdown-alignVertically{flex-direction:column}.tableNumberDropdown-labelContainer{display:flex;align-items:center}.tableNumberDropdown-dropdownContainer{width:auto}.tableNumberDropdown-labelTitleText{font-size:14px;font-family:'Lato-Regular', sans-serif;color:var(--text)}.tableNumberDropdown-menuListRoot{padding-right:1vw}\n", ""]);

// exports
